import React from 'react'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'
import { useUpspaceRoom } from 'hooks/useUpspaceRoom'

import { UserType } from 'types/user'

import { CoachItem } from './CoachItem'

type ChatCoachItemProps = {
  user: UserType
  isSquare?: boolean
  withLeaderboardPosition?: boolean
  isUpspace?: boolean
}

export const ChatCoachItem = ({ user, ...rest }: ChatCoachItemProps) => {
  const { data: currentUser } = useCurrentUser()
  const { data: group } = useGroup({ userId: user.id })
  const { data: room } = useUpspaceRoom({ program: group, userId: currentUser?.id })

  return <CoachItem room={room} user={user} {...rest} />
}
